import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../auth/store/loginSlice';
import { CssBaseline, Grid, Paper, Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
	root: {
		height: '100vh',
	},
	image: {
		backgroundRepeat: 'no-repeat',
		backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	},
	paper: {
		paddingTop: 40,
		alignItems: 'center',
		textAlign: 'center',
		width: '90%',
		margin: 'auto',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},

	logo: {
		maxWidth: '400px',
	},
}));

function Logout() {
	const classes = useStyles();
	const { logout } = useAuth0();
	const dispatch = useDispatch();

	useEffect(() => {
		localStorage.removeItem('HammurabiAuth');
		logout();
		dispatch(logoutUser());
	}, [dispatch, logout]);

	const [bgNumber, setBgNumber] = useState(null);

	useEffect(() => {
		if (!bgNumber) {
			const rndInt = Math.floor(Math.random() * 6) + 1;
			setBgNumber(rndInt);
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Grid container component='main' className={classes.root}>
			<CssBaseline />
			<Grid item xs={false} sm={4} md={7} className={clsx(classes.image, `bg-login-${bgNumber}`)} />
			<Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
				<Grid item className={classes.paper}>
					<img
						src='/assets/img/logo.png'
						alt='simply borrowed logo'
						className={classes.logo}
						style={{ margin: 'auto' }}
					/>
					<Grid item container className={classes.paper}>
						<Grid item xs={12}>
							<Typography variant='body2'>Logging you Out, please wait...</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

export default Logout;
